export default "__VITE_ASSET__BGSoeh5K__"